import { useState } from "react";

import { IPromiseStatus } from "../../Async/types";


export const usePromiseStatus = <ResultT, ErrorT = any>():
    IPromiseStatus<ResultT, ErrorT> => {

    const [hasStarted, setHasStarted] = useState<boolean>(false);
    const [isBusy, setIsBusy] = useState<boolean>(false);
    const [error, setError] = useState<any | null>(null);
    const [isComplete, setIsComplete] = useState<boolean>(false);
    const [result, setResult] = useState<ResultT | null>(null);

    const setPromise = (promise: Promise<ResultT>) => {
        setHasStarted(true);
        setError(null);
        setIsComplete(false);
        setResult(null);

        setIsBusy(true);

        promise.then((result) => {
            setResult(result);
            setIsComplete(true);
        })
        .catch((error) => {
            setError(error);
        })
        .finally(() => {
            setIsBusy(false);
        });

        return promise;
    };

    const clear = () => {
        setHasStarted(false);
        setError(null);
        setIsComplete(false);
        setResult(null);
        setIsBusy(false);
    };

    return {
        setPromise,
        hasStarted,
        error,
        hasError: error != null,
        isBusy,
        isComplete,
        result,
        clear
    };
};